// appviews.js
// import { Platform } from "react-native";

// Public Views
import Login from "../Views/Auth/Login";
import Logout from "../Views/Auth/Logout";
import PasswordReset from "../Views/Auth/PasswordReset";
import Register from "../Views/Auth/Register";

// Main menu pages
import Home from "components/Views/Home";
import Appointments from "components/Views/Appointments";
import Profile from "components/Views/Profile";

// // Inactive Account
// import Inactive from "../Views/Inactive";
// // Downtime / Scheduled Maintenance
// import Offline from "../Views/Offline";
// import Downtime from "../Views/Downtime";

//  /!\ Lower-case key names! /!\  \\
const appviews = {

  // Public pages
  // ⬇ LOGIN MUST BE FIRST BY DESIGN TO IT'S THE DEFAULT SCREEN
  login: {
    title: "Log In",
    view: Login,
    noheader: true,
    private: false,
    superadmin: false,
    menu: "",
  },

  passwordreset: {
    title: "Reset Password",
    view: PasswordReset,
    noheader: true,
    private: false,
    superadmin: false,
    menu: "",
  },

  register: {
    title: "Sign Up",
    view: Register,
    noheader: true,
    private: false,
    superadmin: false,
    menu: "",
  },

  // Main Menu Items
  home: {
    title: "Home",
    view: Home,
    private: true,
    superadmin: false,
    menu: "main",
    icon: "home",
  },

  appointments: {
    title: "Appointments",
    view: Appointments,
    private: true,
    superadmin: false,
    menu: "main",
    icon: "calendar",
  },

  profile: {
    title: "Profile",
    view: Profile,
    private: true,
    superadmin: false,
    menu: "main",
    icon: "user",
  },

  logout: {
    title: "Log out",
    //view: Logout,
    //function: () => window.main.lib.setCurrentView("Logout"), // when function is needed
    function: Logout,  // view: Logout, // function not found error
    private: true,
    superadmin: false,
    menu: "main",
    icon: "log-out",
  },

  // inactive: {
  //   title: "Inactive Account",
  //   view: Inactive,
  //   noheader: true,
  //   external: true,
  //   private: false,
  //   superadmin: false,
  //   menu: "",
  // },
  // downtime: {
  //   title: "Scheduled Maintenance",
  //   view: Downtime,
  //   noheader: true,
  //   external: true,
  //   private: false,
  //   superadmin: false,
  //   menu: "",
  // },
  // offline: {
  //   title: "Offline",
  //   view: Offline,
  //   noheader: true,
  //   external: true,
  //   private: false,
  //   superadmin: false,
  //   menu: "",
  // },

};

appviews.keys = Object.keys(appviews);
appviews.publicKeys = Object.keys(appviews).filter(key=>(!appviews[key].private));
appviews.mainMenuKeys = Object.keys(appviews).filter(key=>(appviews[key].menu==="main"));
// appviews.externalKeys = Object.keys(appviews).filter(key => !!appviews[key].external && !!appviews[key].menu!=="admin");

export default appviews;
